import { render, staticRenderFns } from "./LogItem.vue?vue&type=template&id=04fcea46"
import script from "./LogItem.vue?vue&type=script&lang=js"
export * from "./LogItem.vue?vue&type=script&lang=js"
import style0 from "./LogItem.vue?vue&type=style&index=0&id=04fcea46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports